 
    <mat-card class="filter">
      <label>Inbox</label>      
      <div class="slAct">        
      </div>

      <div class="projectSearch">
      
        <button class="searchbtn" [disabled]="pageModelData.searchValue==''"  mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
       
        <input placeholder="Search Inbox" type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />

      </div>

      <!-- <mat-form-field appearance="">
        <mat-label>Search... </mat-label>
        <input matInput type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
        <button [disabled]="pageModelData.searchValue==''" matSuffix mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>        
      </mat-form-field>   -->
    </mat-card>

  
   <mat-card class="emailList">     
    <mat-table  [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
      <ng-container matColumnDef="fileManagerInboxID">
        <div *matHeaderCellDef class="check">
           <mat-checkbox color="primary" [disabled]="noRecordFound"
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()">
        </mat-checkbox>
        </div>
        <div *matCellDef="let inbox" class="check">
          <mat-checkbox color="primary" (change)="isAllSelectedRow($event,inbox)"
          (change)="$event ? selection.toggle(inbox) : null"
          [checked]="selection.isSelected(inbox)">
        </mat-checkbox>
        </div>
      </ng-container>

      <ng-container matColumnDef="name">
        <div *matHeaderCellDef mat-sort-header class="subject">
          Name
        </div>

        <div *matCellDef="let inbox" class="subject"  (click)="openDocumentViewer(true,inbox,docViewer)">
          <h4>{{ inbox.name }}</h4>
        </div> 
      </ng-container>   
     
      <ng-container matColumnDef="receivedOn">
        <div *matHeaderCellDef mat-sort-header class="update">Received On</div>
        <p *matCellDef="let inbox" class="update sepDateTime"> 
          <span>{{ inbox.createdOn | date: "MM/dd/yyyy"}}</span>
          <span class="time" >{{ inbox.createdOn | date: "h:mm a"}}</span>
        </p>
      </ng-container>
      
      <ng-container matColumnDef="action">
        <div class="action" *matHeaderCellDef>Action</div>

      <div class="action" *matCellDef="let inbox">        
        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Move to another folder" >
          <mat-icon>low_priority</mat-icon>
        </button>        
        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Move to trash">
            <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
      </ng-container>

      <mat-header-row  class="list ehead" *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row  class="list erow" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div *ngIf="noRecordFound" class="noRecordFound" >No Record Found</div>

     
  <mat-paginator *ngIf="!noRecordFound" [length]="paginatorTotalLength"
  [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
  itemsPerPageLabel="Records Per Page" showFirstLastButtons
  (page)="pageEventPropogate($event)">
  </mat-paginator>
  </mat-card> 

  <ng-template #docViewer>
    <app-document-viewer
    (getCloseDocumentViewer)="getCloseDocumentViewer($event)"
    [ngClass]="{ open: documentViewer }"
    [folderID]="folderId"
    [docData]="SelectedDocumentForFileManager">
  </app-document-viewer>
  </ng-template>

